(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name stationFlightHandling.service:StationFlightHandlingService
     *
     * @description
     *
     */
    angular
    	.module('stationFlightHandling')
        .service('StationFlightHandlingService', StationFlightHandlingService);

    function StationFlightHandlingService(RemoteService) {
    	var vm = this;

      vm.searchStationFlightHandlingData = function(param,success,errorFn){

        RemoteService.searchStationFlightHandlingData(param).then(
          function (response) {
              success(response);


          },function(error){
            errorFn(error);

            console.log(error);
          }
        )
      }


      vm.updateStationFlightHandlingData = function(param,success,errorFn){

        RemoteService.updateStationFlightHandlingData(param).then(
          function (response) {
            success(response);

          },function(error){
            errorFn(error);

          }
        )
      }

      vm.getAuditData = function(param,success,errorFn){
        RemoteService.getStationFlightHandlingAuditData(param).then(
          function (response) {
            success(response);

          },function(error){
            errorFn(error);

          }
        )
      }

      vm.getStationFlightHandlingStationForSearch = function(success,errorFn){
        RemoteService.getStationFlightHandlingStationForSearch().then(
          function (response) {
            success(response);

          },function(error){
            errorFn(error);
          }
        )
      }


    }
})();
